var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-map-tool-group',_vm._l((_vm.items),function(item){return _c('o-map-tool-item',{key:item.iconName,attrs:{"iconName":item.iconName},on:{"click":item.action}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }